<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row style="display: flex">
          <el-form :inline="true" :model="searchCondition">
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" />
            </el-form-item>
            <el-form-item>
              <el-button @click="searchButton" style="color: #1890ff"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
          <!-- <el-select
            v-model="valueA"
            placeholder="请选择"
            class="application-wrapper"
            size="medium"
            @click="changeCompany"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="valueB"
            placeholder="请选择"
            class="application-wrapper"
            size="medium"
            @click="changeServiceCompany"
          >
            <el-option
              v-for="item in serviceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </el-row>
        <el-row>
          <div style="display: flex;justify-content: space-between;">
            <ScreeCompany @ScreeCompany="ScreeCompany" />
            <!-- <span> -->
            <el-button
              :loading="downloadLoading"
              style="margin:0 10px 15px 20px;text-align: right;"
              size="medium"
              icon="el-icon-document"
              @click="handleDownload"
            >
              导出
            </el-button>
          </div>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in this.tabsList"
            :label="item.label"
            :key="index"
            :name="item.name"
            class="tab-item tabParent"
          >
            <span slot="label">
              <span v-if="item.name == 'toExamine'" class="tabChild">{{
                toExamineTotal
              }}</span>
              {{ item.label }}
            </span>
          </el-tab-pane>
          <ApeTable
            ref="apeTable"
            :data="dataList"
            :columns="columns"
            :loading="loadingStaus"
            :pagingData="pagingData"
            highlight-current-row
            @switchPaging="switchPaging"
          >
		<el-table-column
		slot="first-column"
		align="center"
		prop="id"
		sortable
		label="编号"
		>
		<template slot-scope="scope">
		{{ scope.row.id }}
		</template>
		</el-table-column>
		<el-table-column
		slot="second-column"
		prop="invoice_type"
		align="center"
		
		label="开票类型"
		>
		<template slot-scope="scope">
		<div>
		{{ scope.row.is_labor_dispatch===0?'充值金额':'劳务费' }}
		</div>
		</template>
		</el-table-column>
            <el-table-column width="100" align="center" label="开票状态">
              <template slot-scope="scope">
                <div>{{ scope.row.alias_status }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="驳回原因">
              <template slot-scope="scope">
                <div style="color: #f56c6c">{{ scope.row.review_remark }}</div>
              </template>
            </el-table-column>
            <el-table-column width="300" align="left" label="操作">
              <template slot-scope="scope">
                <span >
                  <el-button
                    size="mini"
                    type="primary"
                    @click="toExamine(scope.row)"
                    class="operation-btn"
                    v-if="
                      scope.row.alias_status == '审核中' &&
                        userPermissions.indexOf('invoice_edit') != -1
                    "
                    >审核</el-button
                  >
                </span>
                <span>
                  <el-button
                    type="text"
                    @click="viewApplyDetails(scope.row)"
                    class="operation-btn"
                    v-if="
                      scope.row.alias_status == '驳回' ||
                        scope.row.alias_status == '开票中' ||
                        scope.row.alias_status == '审核中' ||
                        scope.row.alias_status == '复核中' ||
                        scope.row.alias_status == '复核通过' ||
                        scope.row.alias_status == '复核失败' ||
                        scope.row.alias_status == '发票寄出'
                    "
                    >申请详情</el-button
                  >
				<span v-if="scope.row.is_labor_dispatch===0"><el-button
                    type="text"
                    @click="viewBillDetails(scope.row.id)"
                    class="operation-btn"
                    v-if="
                      scope.row.alias_status == '复核中' ||
                        scope.row.alias_status == '复核通过' ||
                        scope.row.alias_status == '复核失败' ||
                        scope.row.alias_status == '发票寄出'
                    "
                    >开票详情</el-button
                  ></span>
                  
                  <el-button
                    type="text"
                    @click="viewExpressInfo(scope.row.id)"
                    class="operation-btn"
                    v-if="scope.row.alias_status == '发票寄出'&&scope.row.is_labor_dispatch===0"
                    >快递详情</el-button
                  >
                </span>
                <el-popover
                  v-if="userPermissions.indexOf('invoice_edit') != -1 && scope.row.status === 2"
                  placement="top"
                  width="100"
                  v-model="scope.row.visible">
                  <p>确定要强制驳回吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="forceRefuse(scope.row.id, 6)">确定驳回</el-button>
                  </div>
                  <el-button class="operation-btn" slot="reference" type="danger" size="mini">强制驳回</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </ApeTable>
        </el-tabs>
      </div>
      <!-- 查看开票详情 -->
      <ModalDialog
        :dialogData="invoiceDialogData"
        @dialogConfirm="invoiceHandleConfirm"
        @dialogClose="invoiceDialogClose"
        :showButton="showButton"
        :checkTitle="checkTitle"
      >
        <template slot="content">
          <el-form
            :model="invoiceForm"
            ref="invoiceForm"
            class="demo-ruleForm"
            :label-position="'right'"
          >
            <el-form-item prop="invoiceNumber">
              <template slot="label">
                <div class="mail-title">数目：</div>
              </template>
              <span class="mail-content">{{ invoiceForm.invoiceNumber }}</span>
            </el-form-item>
            <el-form-item prop="invoice">
              <template slot="label">
                <div class="mail-title">发票：</div>
              </template>
            </el-form-item>

            <div v-for="(item, index) in invoiceForm.invoice" :key="index">
              <el-tooltip class="box-item" effect="dark" :content="item" placement="top-start"  v-if="item.slice(-4) == '.pdf' || item.slice(-4).toLowerCase() == '.zip' || item.slice(-4).toLowerCase() == '.rar'" > 
                <img
                @click="goPage(item)"
                style="width: 60px; height: auto; cursor: pointer"
                :src="item.slice(-4) == '.pdf' ? 'https://xl-online.oss-cn-hangzhou.aliyuncs.com/xladmin/static/icon_pdf.png' : 'https://img.51xinlong.com/xladmin/static/icon_zip.png'"
              />
              </el-tooltip>
              <img
                v-else
                :class="index != 0 ? 'new-mail-img' : 'mail-img'"
                :src="item"
              />
            </div>
            <div
              v-if="invoiceForm.invoiceNumber > 1"
              @click="expendMore"
              class="expend"
            >
              展开
            </div>
          </el-form>
        </template>
      </ModalDialog>
      <!-- 查看快递 -->
      <ModalDialog
        :dialogData="dialogData"
        @dialogConfirm="handleConfirm"
        @dialogClose="dialogClose"
        :showButton="showButton"
        :checkTitle="checkTitle"
      >
        <template slot="content">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            class="demo-ruleForm"
            :label-position="'right'"
          >
            <el-form-item prop="expressName">
              <template slot="label">
                <div class="mail-title">快递名称：</div>
              </template>
              <span class="mail-content">{{ ruleForm.expressName }}</span>
            </el-form-item>
            <el-form-item prop="courierNumber">
              <template slot="label">
                <div class="mail-title">快递单号：</div>
              </template>
              <span class="mail-content">{{ ruleForm.courierNumber }}</span>
            </el-form-item>
            <!-- <el-form-item prop="invoice">
              <template slot="label">
                <div class="mail-title">快递图片：</div>
              </template>
            </el-form-item>
            <div v-for="(item, index) in ruleForm.invoice" :key="index">
              <img :class="index != 0 ? 'new-mail-img' : 'mail-img'" :src="item"/>
            </div>
            <div v-if="ruleForm.invoice.length > 1" @click="expendMore" class="expend">展开</div> -->
          </el-form>
        </template>
      </ModalDialog>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from "@/components/ModalDialog";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import ScreeCompany from "@/components/ScreeCompany.vue";
import exceljs from "exceljs";
import FileSaver from "file-saver";
import { mapGetters } from "vuex";
import { debounce } from 'lodash'

export default {
  name: "admin_invoice",
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog,
    DatePicker,
    ScreeCompany,
  },
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  data() {
    return {
      ruleForm: {
        expressName: "",
        courierNumber: "",
        invoice: "",
      },
      invoiceForm: {
        invoiceNumber: "",
        invoice: "",
      },
      invoiceDialogData: {
        visible: false,
        title: "",
        width: "40%",
        loading: false,
        modal: false,
      },
      dialogData: {
        visible: false,
        title: "发票查看",
        width: "40%",
        loading: false,
        modal: false,
      },
      showButton: ["cancel"],
      checkTitle: "关闭",
      loadingStaus: false,
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      toExamineTotal: 0,
      options: [
        {
          value: "北京筑帷科技有限公司",
          label: "北京筑帷科技有限公司",
        },
        {
          value: "北京筑帷科技有限公司1",
          label: "北京筑帷科技有限公司1",
        },
        {
          value: "北京筑帷科技有限公司2",
          label: "北京筑帷科技有限公司2",
        },
        {
          value: "北京筑帷科技有限公司3",
          label: "北京筑帷科技有限公司3",
        },
      ],
      serviceOptions: [
        {
          value: "河南科朗尼",
          label: "河南科朗尼",
        },
        {
          value: "河南科朗尼1",
          label: "河南科朗尼1",
        },
        {
          value: "河南科朗尼2",
          label: "河南科朗尼2",
        },
        {
          value: "河南科朗尼3",
          label: "河南科朗尼3",
        },
      ],
      valueA: "公司名称",
      valueB: "服务公司",
      tabsList: [
        {
          label: "全部",
          name: "all",
        },
        {
          label: "审核中",
          name: "toExamine",
        },
        {
          label: "驳回",
          name: "refuse",
        },
        {
          label: "开票中",
          name: "billing",
        },
        {
          label: "复核中",
          name: "underReview",
        },
        {
          label: "复核通过",
          name: "passThereview",
        },
        {
          label: "复核驳回",
          name: "reviewRejected",
        },
        {
          label: "发票寄出",
          name: "invoiceSent",
        },
      ],
      activeName: "all",
      dataList: [],
      columns: [
  //       {
  //         title: "编号",
  //         value: "id",
  //         header_align: "center",
  //         align: "center",
  //       },
		// {
		// title: "开票类型",
		// value: "id",
		// header_align: "center",
		// align: "center",
		// },
        {
          title: "申请开票时间",
          value: "created_at",
          header_align: "center",
          align: "center",
        },
        {
          title: "申请开票金额",
          value: "invoice_money",
          header_align: "center",
          align: "center",
        },
        {
          title: "账户余额",
          value: "balance_money",
          header_align: "center",
          align: "center",
        },
        {
          title: "客户名称",
          value: "company_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "开票公司",
          value: "channel_name",
          header_align: "center",
          align: "center",
        },
      ],
      searchCondition: {
        start_time: "",
        end_time: "",
        status: "",
        invoice_status: "",
        company_id: "",
      },
      downloadLoading: false,
      exportSearch: {
        start_time: "",
        end_time: "",
      },
    };
  },
  methods: {
    goPage(e) {
      // location.href = e;
      window.open(e, "_blank"); //新标签打开生成的pdf
    },
    //分页
    switchPaging() {
      this.init();
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    ScreeCompany(v, name) {
      if (name == "company") {
        if (v) {
          this.searchCondition.company_id = v;
        } else {
          delete this.searchCondition.company_id;
        }
        this.init("search");
      }

      if (name == "settlement") {
        if (v) {
          this.searchCondition.channel_account = v;
        } else {
          delete this.searchCondition.channel_account;
        }
        this.init("search");
      }
    },
    //展开更多图片
    expendMore() {
      let node = document.getElementsByClassName("new-mail-img");
      for (let i = 0; i < node.length; i++) {
        node[i].style.display = "block";
      }
      let expend = document.getElementsByClassName("expend")[0];
      expend.style.display = "none";
    },
    //获取选中日期的值
    dataSearch(value) {
      if (value) {
        this.searchCondition.start_time = value[0];
        this.searchCondition.end_time = value[1];
      } else {
        delete this.searchCondition.start_time;
        delete this.searchCondition.end_time;
      }
    },
    //获取开票审核列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      if (searchCondition.sign_type == "all") {
        delete searchCondition.sign_type;
      }
      Object.assign(searchCondition, pagingInfo);
      let { data, pages } = await this.$api.getInvoiceAuditList(
        searchCondition
      );
      this.$nextTick(() => {
        this.dataList = data;
      });
      this.pagingData.total = pages.total;
      this.offset = pages.offset;
      this.loadingStaus = false;
      this.toExamineTotal = pages.process_total;
    },
    // 选择公司
    changeCompany(e) {
      console.log(e, "公司");
      this.searchCondition.company = e;
    },
    // 选择服务公司
    changeServiceCompany(e) {
      console.log(e, "服务公司");
      this.searchCondition.serviceCompany = e;
    },
    //点击tab切换
    async handleClick(tab) {
      if (tab.name == "all") {
        // 全部
        delete this.searchCondition.status;
        delete this.searchCondition.invoice_status;
        this.init("all");
      } else if (tab.name == "toExamine") {
        // 审核中
        this.searchCondition.status = 1;
        delete this.searchCondition.invoice_status;
        this.init("toExamine");
      } else if (tab.name == "refuse") {
        // 驳回
        this.searchCondition.status = 3;
        delete this.searchCondition.invoice_status;
        this.init("refuse");
      } else if (tab.name == "billing") {
        // 开票中
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 1;
        console.log(
          "billing",
          this.searchCondition.status,
          this.searchCondition.invoice_status
        );
        this.init("billing");
      } else if (tab.name == "underReview") {
        // 复核中
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 2;
        this.init("underReview");
      } else if (tab.name == "passThereview") {
        // 复核通过
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 3;
        this.init("passThereview");
      } else if (tab.name == "reviewRejected") {
        // 复核驳回
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 5;
        this.init("reviewRejected");
      } else if (tab.name == "invoiceSent") {
        // 发票寄出
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 4;
        this.init("invoiceSent");
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.status === 0 || this.searchCondition.status) {
        condition.status = this.searchCondition.status;
      }
      if (
        this.searchCondition.invoice_status === 0 ||
        this.searchCondition.invoice_status
      ) {
        condition.invoice_status = this.searchCondition.invoice_status;
      }
      if (this.searchCondition.start_time) {
        condition.start_time = this.searchCondition.start_time;
      }
      if (this.searchCondition.end_time) {
        condition.end_time = this.searchCondition.end_time;
      }

      if (this.searchCondition.company_id) {
        condition.company_id = this.searchCondition.company_id;
      }
      if (this.searchCondition.channel_account) {
        condition.channel_account = this.searchCondition.channel_account;
      }
      return condition;
    },
    //处理发票模态框，确定事件
    invoiceHandleConfirm() {
      this.invoiceForm = {};
      this.invoiceDialogData.visible = false;
    },
    //处理发票模态框，关闭事件
    invoiceDialogClose() {
      this.invoiceForm = {};
      this.invoiceDialogData.visible = false;
    },

    //查看快递详情
    async viewExpressInfo(id) {
      this.dialogData.loading = false;
      this.dialogData.visible = true;
      this.dialogData.title = `快递信息查看${id}`;
      this.checkTitle = "关闭";
      let args = { id: id };
      let result = await this.$api.invoiceAuditExpressDetails(args);
      if (result) {
        this.ruleForm = {
          expressName: "顺丰",
          courierNumber: result.express_no,
          invoice: result.express_img.split(","),
        };
      }
    },
    // 强制驳回
    forceRefuse:debounce(async function(id,type){
      let args = {
        id,
        status: type, //审核状态：2-审核通过,3-审核不通过 6 - 强制驳回
      }
      let info = await this.$api.invoiceAudit(args)
      if (info) {
        this.$message.success('操作成功!')
        this.init()
      } else {
        this.$message.error(info)
      }
    },1000,{leading:true,trailing:false}),
    // 审核
    toExamine(option) {
		const row=option
		if(option.is_labor_dispatch===1){
			this.$router.push({
			path: "/admin_invoice/laowu_detail",
			query: { id: row.id, title: "开票详情", isExamine: row.alias_status == '审核中'},
			});
			return
		}
     
      this.$router.push({
        path: "/admin_invoice/detail",
        query: { id: option.id, title: "开票审核", isExamine: true },
      });
    },
    //查看开票详情
    async viewBillDetails(id) {
      this.invoiceDialogData.title = `发票${id}`;
      this.invoiceDialogData.visible = true;
      this.checkTitle = "关闭";
      let args = {
        id: id,
      };
      let result = await this.$api.invoiceAuditDetail(args);
      if (result) {
        this.invoiceForm = {
          invoiceNumber: result.invoice_img_num,
          invoice: result.invoice_imgs,
        };
      }
    },
    //查看申请详情
    viewApplyDetails(option) {
		const row=option
		if(option.is_labor_dispatch===1){
			this.$router.push({
			path: "/admin_invoice/laowu_detail",
			query: { id: row.id, title: "开票详情" },
			});
			return
		}
      this.$router.push({
        path: "/admin_invoice/detail",
        query: { id: row.id, title: "开票审核" },
      });
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.dialogData.visible = false;
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false;
      this.dialogData.loading = true;
    },
    //导出
    async handleDownload() {
      let searchCondition = this.handleSearchCondition()
      console.log(searchCondition, "搜索条件");
      let { data } = await this.$api.getInvoiceAuditList({
        current_page: 1,
        page_size: 50000,
        ...searchCondition,
      });
      data.forEach((ele,index) => {
        ele.index = index + 1
        console.log(ele);
        ele.invoice_type = ele.invoice_type == 1 ? "专票" : "普票";
        ele.invoice_category_name = ele.invoice_category_name.join(',')
        ele.remittance_name = ele.company.name
        ele.remittance_taxpayer = ele.company.taxpayer
        ele.remittance_address = ele.company.address + ','  + ele.company.legal_phone
        ele.remittance_bank = ele.company.bank + ','  + ele.company.account 
      });
      console.log(data,'导出的数据');
      let exportData = JSON.parse(
        JSON.stringify(data)
      );
      const workbook = new exceljs.Workbook();
      const worksheet = workbook.addWorksheet("开票审核");
      let wscolumns = [
        { header: "序号", key: "index", width: 10 },
        { header: "编号", key: "id", width: 12 },
        { header: "使用开票公司", key: "channel_name", width: 25 },
        { header: "汇款公司名称", key: "invoice_title", width: 30 },
        { header: "开票名目", key: "invoice_category_name", width: 30 },
        { header: "发票类型", key: "invoice_type", width: 15 },
        { header: "金额", key: "invoice_money", width: 10 },
        { header: "汇款单位开票信息", key: "remittance_name", width: 30 },
        { header: "纳税人识别号", key: "remittance_taxpayer", width: 30 },
        { header: "地址电话", key: "remittance_address", width: 30 },
        { header: "开户银行及账号", key: "remittance_bank", width: 30 },
        { header: "备注", key: "remark", width: 20 },
      ];
      worksheet.columns = wscolumns;
      worksheet.mergeCells("A1:A2");
      worksheet.mergeCells("B1:B2");
      worksheet.mergeCells("C1:C2");
      worksheet.mergeCells("D1:D2");
      worksheet.mergeCells("E1:E2");
      worksheet.mergeCells("F1:F2");
      worksheet.mergeCells("G1:G2");
      worksheet.mergeCells("H1:K1");
      worksheet.mergeCells("L1:L2");
      worksheet.getCell("H2").value = "单位名称";
      worksheet.getCell("I2").value = "纳税人识别号";
      worksheet.getCell("J2").value = "地址电话";
      worksheet.getCell("K2").value = "开户银行及账号";
      worksheet.addRows(exportData);
      const arr = ['D1','E1','G1','H2','I2','J2','K2']
      arr.forEach(ele => {
        worksheet.getCell(ele).font = {
          color: { argb: 'ff0000' },
        }
      })
      const arrbg = ['H1','H2','I2','J2','K2']
      arrbg.forEach(ele => {
        worksheet.getCell(ele).fill  = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'ffff00' },
        }
      })
      const arrcenter = ['A1','B1','C1','D1','E1','F1','G1','H1','L1','H2','I2','J2','K2']
      arrcenter.forEach(ele => {
        worksheet.getCell(ele).alignment = { horizontal: "center" };
      })
      // 写入本地文件
      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
        FileSaver.saveAs(blob, `开票审核导出.xlsx`);
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.tabParent{
  position relative;
}

.tabChild{
  position absolute;
  left 62px;
  top 5px;
  padding 10px;
  height 20px;
  border-radius 20px;
  box-sizing border-box;
  background-color #ff557f;
  color #fff;
  display flex;
  justify-content center;
  align-items center;
  font-size 12px;
  z-index 999;
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.operation-btn {
  margin: 0 10px;
}

.el-button + .el-button {
  margin-left: 0;
}

.item-info {
  display: flex;
  flex-direction: row;
}

.item-info-left {
  width: 130px;
  height: 130px;
}

.item-info-right {
  width: 200px;
  padding: 15px;
  line-height: 40px;
}

.item-info-title {
  color: #aeaeb2;
  font-size: 18px;
}

.item-info-price {
  color: #101010;
  font-size: 28px;
}

.item-info-progress {
  width: 76px;
  height: 11px;
  border: 1px solid black;
}

.border-right {
  border-right: 2px solid #BBBBBB;
}

.application-wrapper {
  width: 280px;
  margin-left: 30px;
}

.new-mail-img {
  display: none;
  width: 100%;
}

.invoice-img {
  width: 100%;
  height: 300px;
  border: 1px solid black;
}

.mail-title {
  color: rgba(16, 16, 16, 100);
  font-size: 16px;
}

.mail-content {
  color: rgba(16, 16, 16, 100);
  font-size: 16px;
}

.mail-img {
  width: 100%;
}

.expend {
  text-align: center;
  margin-top: 20px;
  color: #333;
}
</style>
